<template>
  <div
    v-if="loaded"
    class="content-devx main-dx-extreme-weather-condicions-database"
  >
    <DxDataGrid
      id="extremeWeatherCondicionsGrid"
      :data-source="extremeWeatherCondicionsFormated"
      :column-min-width="90"
      :column-auto-width="true"
      :allow-column-reordering="true"
      :show-borders="true"
      :show-column-lines="true"
      :show-row-lines="true"
      :row-alternation-enabled="true"
      @exporting="onExporting"
      @toolbar-preparing="onToolbarPreparing($event)"
    >
      <DxSelection
        mode="single"
      />
      <DxStateStoring
        :enabled="true"
        type="localStorage"
        storage-key="DxExtremeWeatherCondicionsDatabase"
      />
      <DxExport
        :enabled="true"
      />
      <DxHeaderFilter :visible="true" />
      <DxPaging :page-size="10" />
      <DxPager
        :show-page-size-selector="true"
        :allowed-page-sizes="pageSizes"
        :show-info="true"
      />
      <DxSearchPanel
        :visible="true"
        :width="200"
        :placeholder="$t('Search_placeholder')"
      />
      <!--- TODO: Permitir la edición de ExtremeWeatherCondicions
      <DxColumn
        v-if="$helpers.havePermission(getPermissions.company_update_master_data)"
        type="buttons"
        data-field="Actions"
      >
        <DxButton
          icon="edit"
          :hint="$t('DxExtremeWeatherCondicionsDatabase_edit_hint')"
          :on-click="editExtremeWeatherCondicions"
        />
      </DxColumn>
      -->
      <DxColumn
        data-field="type"
        name="type"
        :caption="$t('DxExtremeWeatherCondicionsDatabase_column_type')"
        :allow-header-filtering="true"
      />
      <DxColumn
        data-field="name"
        name="name"
        :caption="$t('DxExtremeWeatherCondicionsDatabase_column_name')"
        :allow-header-filtering="false"
      />
      <DxColumn
        :width="100"
        data-field="photos"
        name="photos"
        :caption="$t('Monitoring_photos')"
        :allow-header-filtering="false"
        cell-template="cellTemplate"
      />
      <template #cellTemplate="{ data }">
        <DxImageScoutingPopup :images="data.value" />
      </template>
    </DxDataGrid>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxSearchPanel,
  DxButton,
  DxExport,
  DxHeaderFilter,
  DxStateStoring,
  DxPager,
  DxSelection,
} from 'devextreme-vue/data-grid';
import { exportDataGrid } from 'devextreme/excel_exporter';
import ExcelJS from 'exceljs';
import saveAs from 'file-saver';
import Api from '../../services/Api';
import DxImageScoutingPopup from './DxImageScoutingPopup.vue';

export default {
  name: 'DxExtremeWeatherCondicionsDatabase',
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxSearchPanel,
    DxButton,
    DxExport,
    DxHeaderFilter,
    DxStateStoring,
    DxPager,
    DxSelection,
    DxImageScoutingPopup,
  },
  data() {
    return {
      loaded: false,
      extremeWeatherCondicionsFormated: [],
      pageSizes: [5, 10, 20],
    };
  },
  computed: {
    ...mapGetters('scouting', ['getActualExtremeWeatherCondicions']),
  },
  async beforeMount() {
    this.$f7.preloader.show();
    try {
      const xhr = await Api.getScoutingMasterData(['EXTREME WEATHER CONDITIONS']);
      const extremeWeatherCondicions = JSON.parse(xhr.response).data;
      for (const extremeWeatherCondicion of extremeWeatherCondicions) {
        this.extremeWeatherCondicionsFormated.push({
          id: extremeWeatherCondicion.id,
          type: extremeWeatherCondicion.type,
          name: extremeWeatherCondicion.name,
          photos: extremeWeatherCondicion.photos,
        });
      }
    } catch (e) {
      const message = this.$helpers.getFilteredErrorMessage(e);
      if (message.includes('default_') && !message.includes('404')) {
        this.$f7.dialog.alert(message.split('_').pop());
      } else if (!message.includes('404')) {
        this.$f7.dialog.alert(this.$t(message));
      }
    } finally {
      this.$f7.preloader.hide();
      this.loaded = true;
    }
  },
  methods: {
    createExtremeWeatherCondicions() {
      this.setActualExtremeWeatherCondicions({});
      this.$f7.views.main.router.navigate('/createExtremeWeatherCondicions/', { reloadCurrent: true });
    },
    editExtremeWeatherCondicions(rowSelected) {
      this.setActualExtremeWeatherCondicions(rowSelected.row.data);
      this.$f7.views.main.router.navigate('/editExtremeWeatherCondicions/', { reloadCurrent: true });
    },
    onToolbarPreparing(e) {
      return; // TODO: Permitir la creación de ExtremeWeatherCondicions
      if (!this.$helpers.havePermission(this.getPermissions.company_update_master_data)) return;
      e.toolbarOptions.items.unshift({
        location: 'before',
        widget: 'dxButton',
        options: {
          icon: 'add',
          elementAttr: {
            class: 'add-task',
          },
          text: this.$t('DxExtremeWeatherCondicionsDatabase_button_create_text'),
          onClick: () => {
            this.createExtremeWeatherCondicions();
          },
        },
      });
    },
    // EXPORT EXCEL
    onExporting(e) {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('ExtremeWeatherCondicionsDatabase');
      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer()
          .then((buffer) => {
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'ExtremeWeatherCondicionsDatabase.xlsx');
          });
      });
      e.cancel = true;
    },
    ...mapActions('scouting', ['setActualExtremeWeatherCondicions']),
  },
};
</script>
